var lang = 'es-AR';

var aplicaciones;
$.getJSON('/wp-content/themes/sabbione/js/aplicaciones.json')
  .done(function (data) {
    aplicaciones = data;
    loadBrandsList();
  });

var productos;
$.getJSON('/wp-content/themes/sabbione/js/productos.json')
  .done(function (data) {
    productos = data;
  });

function appendOption(value, element) {
  var valueClean = lang == 'en-US' ? value.replace('Hasta','Until').replace('Desde','Since').replace('Todas las versiones','All versions').replace('Toda la línea','All versions') : value,
      option = '<option value="'+value+'">'+valueClean+'</option>';
  $('#'+element).append(option);
}

function loadBrandsList() {
  var brands = [];

  $.each(aplicaciones, function(index) {
    var brand = aplicaciones[index]['marca'];

    if ($.inArray(brand, brands) < 0) {
      brands.push(brand);
    }

  });

  brands.forEach(function(brand, index) {
    appendOption(brand, 'marca');
  });
  $('#marca').prop('disabled', false);
}

function loadModel() {
  $('#marca').on('change', function() {
    var value = $(this).val();

    $('#modelo').empty();

    $.each(aplicaciones, function(index, aplicacion) {

      if (aplicacion['marca'] == value) {
        appendOption(aplicacion['modelo'], 'modelo');
      }

    });

    $('#modelo').prop('disabled', false);
  });
}

function getBatteryData(bateria) {
  if ($('.current-lang a').attr('lang')) {
    lang = $('.current-lang a').attr('lang');
  }

  var bateriaTraducida = lang == 'en-US' ? bateria.replace(' - Derecha',' - Right').replace(' - Izquierda',' - Left') : bateria ,
      bateriaClean = bateria.replace(/ - Derecha| - Izquierda|/gi,'');

  $.each(productos[0][lang], function(index, producto) {
    var tipo;
    if (lang == 'en-US') {
      tipo = producto['Type'];
    } else {
      tipo = producto['Tipo'];
    }

    if (tipo == bateriaClean) {
      $('#data').empty();

      for (var prop in producto) {
        if (producto.hasOwnProperty(prop)) {
          if (prop == 'Tipo'||prop == 'Type') {
            $('#bateria').html(bateriaTraducida);
            $('#bateria-img').prop('src', 'assets/img/products/'+tipo+'.png');
          } else {
            $('#data').append(
              '<div class="c-attr">'+
              '<div class="c-attr__key"><span>'+prop+':</span></div>'+
              '<div class="c-attr__value"><span>'+producto[prop]+'</span></div>'+
              '</div>'
            );
          }
        }
      }
    }

  });
}

function returnBattery() {
  $('#buscar').on('click', function() {
    var marca = $('#marca').val(),
        modelo = $('#modelo').val();

    if (marca == '') {
      $('#marca').addClass('error');
    } else {
      $('#marca').removeClass('error');
      $.each(aplicaciones, function(index, aplicacion) {

        if (aplicacion['marca'] == marca && aplicacion['modelo'] == modelo) {
          getBatteryData(aplicacion['bateria']);
          $('.c-grid').removeClass('is-empty');
        }

      });
    }

  });
}
